import React from 'react';
export function LegalFooter() {
  return <footer className="bg-navy-light py-10 px-4 md:px-8 pb-24 md:pb-10 border-t border-navy-lighter" data-id="element-33">
      <div className="max-w-4xl mx-auto" data-id="element-34">
        {/* Brand */}
        <div className="flex items-center justify-center gap-2 mb-6" data-id="element-35">
          <img src="https://cdn.magicpatterns.com/uploads/opXSaFkmappgfGitP8aDsi/logo-text_-_Edited.png" alt="The Founders Law" className="h-8 md:h-10 w-auto" data-id="element-36" />
        </div>

        {/* Legal Disclaimers */}
        <div className="space-y-4 text-[10px] md:text-xs text-gray-400 leading-relaxed text-center" data-id="element-37">
          <p data-id="element-38">
            La información contenida en este sitio web es solo información
            general y no constituye asesoramiento legal. Podemos recomendar un
            abogado para una evaluación de su situación particular. El uso,
            acceso o ingreso de información en nuestro sitio web no implica ni
            crea una relación abogado-cliente, ni de manera explícita ni
            implícita.
          </p>

          <p data-id="element-39">
            Al enviar su información, usted está otorgando su consentimiento
            expreso "por escrito" para que los abogados y defensores de The
            Founders Law seleccionados al enviar el formulario lo contacten
            (mediante llamadas automáticas, mensajes de texto y mensajes
            pregrabados por conveniencia) a través de teléfono o dispositivo
            móvil (incluidos SMS y MMS; se pueden aplicar cargos de su operador,
            no por nosotros; la frecuencia de los mensajes varía; envíe HELP
            para obtener ayuda; envíe STOP para cancelar), incluso si su número
            de teléfono se encuentra actualmente en cualquier lista interna,
            corporativa, estatal o federal de No Llamar.
          </p>

          <p data-id="element-40">
            Tomamos su privacidad en serio y puede recibir comunicaciones
            electrónicas, incluidos correos electrónicos periódicos o mensajes
            de texto con noticias importantes, consejos financieros,
            herramientas y más. Siempre puede darse de baja en cualquier
            momento. Todas las interacciones en el sitio web y las llamadas
            telefónicas son grabadas para fines de cumplimiento y aseguramiento
            de la calidad. El consentimiento no es un requisito para utilizar
            los servicios de The Founders Law y no está obligado a comprar nada.
          </p>
        </div>

        {/* Copyright */}
        <div className="mt-6 pt-4 border-t border-navy-lighter text-center text-[10px] md:text-xs text-gray-500" data-id="element-41">
          <p data-id="element-42">
            ©2025 The Founders Law |{' '}
            <a href="#" className="text-orange hover:text-orange-hover underline transition-colors" data-id="element-43">
              Política de privacidad & Términos de uso
            </a>
          </p>
        </div>
      </div>
    </footer>;
}